import { BrowserTimeZone, H12H24 } from "../types";

const dateTimeFormat = Intl.DateTimeFormat().resolvedOptions();

export const BROWSER_TZ = dateTimeFormat.timeZone as BrowserTimeZone;
export const SUPPORTED_TZS = Intl.supportedValuesOf?.("timeZone") as BrowserTimeZone[] | undefined;

// hour12 has low support.  Must do a strict equality check on false.
export const BROWSER_TIME_TYPE: H12H24 = dateTimeFormat.hour12 === false ? "24h" : "12h";
